import { CartStructure, Product, ShippingMethod } from "../components/interfaces/SaleorTypes"

export const calculateSubtotal = (cart: CartStructure[], shippingMethod?: ShippingMethod) => {
  let prices = cart.map((item) => {
    return (item.product?.variants[0]?.pricing.price.gross.amount || 0) * item.amount
  })
  if (shippingMethod && shippingMethod.price) {
    prices.push(shippingMethod.price.amount)
  }
  if (prices.length > 0) {
    return Number(prices.reduce((a, b) => a + b).toFixed(0))
  } else {
    return 0
  }
}

export const calculateItemTotal = (product: Product, amount: number): number => {
  return Number(((product?.variants[0]?.pricing.price.gross.amount || 0) * amount).toFixed(0))
}

export const parseDescription = (description: string) => {
  return JSON.parse(description)?.blocks[0]?.data?.text
}

export const getFormattedPrice = (price: number, currency?: string) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
  })
  let formattedPrice = formatter.format(price)
  // Remove .00 if price is a whole number
  if (Math.floor(price) === price) {
    formattedPrice = formattedPrice.split(".")[0]
  }
  return formattedPrice
}
